module.exports = __webpack_public_path__ + "img/partner-wagner-oscar.2937663a.jpg";